module.exports = new __parcel__URL__("wbd-favicon-128.22691cd3.png").toString();